import { ConsentInterface } from '@wizbii/utils/models';

type Consents = Record<string, ConsentInterface[]>;

export class SetConsents {
  static readonly type = '[SetConsents] Set Consents';
  constructor(public consents: Consents | { [key: string]: boolean } | ConsentInterface[]) {}
}

export class SetConsent {
  static readonly type = '[SetConsent] Set Consent';
  constructor(public consent: ConsentInterface) {}
}
